export default __webpack_public_path__ + "static/LAURA-LEMA-Flor_Mensual-80c7bb499f0030febbc48965079f3645.png";